"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { testimonials2 } from "@/data/data";

interface Props {
    headline: string;
    style?: "style-2" | "style-3";
}

const Testimonial = ({ headline, style }: Props) => {
    return (
        <section
            className={
                style === "style-2"
                    ? "desilo-testimonial-section extend section-padding-top overflow-hidden"
                    : style === "style-3"
                        ? "desilo-testimonial3-section bg-color-2 section-padding-top-bottom"
                        : "desilo-testimonial3-section section-padding-top-bottom"
            }
        >
            <div className="container custom-container">
                <div className="row g-4 justify-content-between overflow-hidden">
                    <div className="col-lg-6 col-xxl-5 pe-xxl-0">
                        <div className="desilo__header h-100">
                            <h2 className="title">
                                {headline}
                            </h2>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xxl-5">
                        <div className="testimonial-slider">
                            <Swiper
                                navigation={{
                                    nextEl: ".next-btn",
                                    prevEl: ".prev-btn",
                                }}
                                modules={[Navigation]}
                                loop={true}
                            >
                                {/* testimonial card start */}
                                {testimonials2.map((item, i) => (
                                    <SwiperSlide key={i}>
                                        <div className="swiper-slide">
                                            <div className="testimonial3-content">
                                                <p>{item.content}</p>
                                                <div className="client-info">
                                                    <h3 className="client-name">
                                                        {item.name}
                                                    </h3>
                                                    <span className="client-designation fw-normal">
                                                        {item.designation}
                                                        {/* {item.company} */}
                                                    </span>
                                                </div>
                                                {/* <Image className="mt-3" src={item.image || ""} alt={item.name} width={100} height={31} /> */}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                                {/* testimonial card end */}
                            </Swiper>
                            <div
                                className="testimonial3-navigation"
                                style={{ cursor: "pointer" }}
                            >
                                <div
                                    className={`prev-btn ${style === "style-3"
                                        ? "bg-color-white"
                                        : "bg-color-2"
                                        }`}
                                >
                                    <i className="fa-solid fa-angle-left" />
                                </div>
                                <div
                                    className={`next-btn ${style === "style-3"
                                        ? "bg-color-white"
                                        : "bg-color-2"
                                        }`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <i className="fa-solid fa-angle-right" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
